import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import TaskViewCardCta from './TaskViewCardCta';
import { useTaskGroupConfigOverrides } from '../../../hooks/viewConfig';
import { useTaskDataByGroupKey } from '../../../hooks/task';
import { CARD_ITEM_LEFT_ICON_SIZE_PX } from '../../../constants/layoutConstants';
import AssignedTaskNotification from './AssignedTaskNotification';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskViewCardHeader = ({
  onboardingKey,
  viewGroupKey,
  onGroupClick
}) => {
  const {
    cta: taskViewCta
  } = useTaskGroupConfigOverrides(onboardingKey, viewGroupKey);
  const {
    description: subtitle,
    illustration: illustrationName,
    name: title
  } = useTaskDataByGroupKey(viewGroupKey);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    paddingBlockEnd: "200",
    paddingBlockStart: "1000",
    paddingInline: "1000",
    children: [illustrationName && /*#__PURE__*/_jsx(Illustration, {
      height: CARD_ITEM_LEFT_ICON_SIZE_PX,
      marginInlineEnd: "400",
      name: illustrationName,
      width: CARD_ITEM_LEFT_ICON_SIZE_PX
    }), /*#__PURE__*/_jsxs("div", {
      children: [title && /*#__PURE__*/_jsx(Text, {
        as: "h3",
        marginBlockEnd: "0",
        children: title
      }), subtitle && /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "0",
        marginBlockStart: "200",
        children: subtitle
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "auto",
      children: /*#__PURE__*/_jsx(AssignedTaskNotification, {
        isInHeader: true,
        onGroupClick: onGroupClick,
        viewGroupKey: viewGroupKey
      })
    }), taskViewCta && /*#__PURE__*/_jsx(TaskViewCardCta, {
      config: taskViewCta,
      "data-test-id": `task-view-card-cta-${taskViewCta.ctaId}`,
      groupKey: viewGroupKey
    })]
  });
};
export default TaskViewCardHeader;